import angular from 'angular';

import * as Configuration from '../app.constants.js';

export class AssertService {
  constructor($state, $http) {
    this.$state = $state;
    this.$http = $http;
  }

  check (condition, message) {
    let self = this;
    if (!condition) {
      let error = new Error('Assert failed: ' + message);
      if (self.$state.transition) {
        // error will be caught in the angularjs exceptionHandler and a
        // bug will be reported at this point.
        throw error;
      } else {
        let bug = {
          message : 'Assert failed: ' + message,
          backtrace: angular.isUndefined(error.stack)?'Backtrace not available':error.stack,
          currentState : self.$state.current.name,
          currentParams : self.$state.params
        };
        self.$http.post(Configuration.constants.baseUrl + 'jsbugs', bug).then(function(result) {
          self.$state.go('bug', {id : result.data.id});
        });
      }
    }
  }

  static AssertFactory($state, $http) {
    return new AssertService($state, $http);
  }

}

AssertService.AssertFactory.$inject = ['$state', '$http'];
